import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import KeycloakManager from "../KeycloakManager";

const PublicRoute = ({ element, ...rest }) => {
  const token = localStorage.getItem('token');
  const isLoggedIn = !!token;

  console.log('public', isLoggedIn, token);

  return isLoggedIn ? <Navigate to="/ticket-lists" /> : <AuthWrapper element={element} />;
};

const AuthWrapper = ({ element }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const keycloakManager = KeycloakManager();

    const initializeKeycloak = async () => {
      const { isLogin, loading } = await keycloakManager.initialize();
      setIsLogin(isLogin);
      setLoading(loading);
    };

    initializeKeycloak();
  }, []);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center heightNodData">
        <img
          src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
          width={50}
          alt="Loading..."
        />
      </div>
    );
  }

  return <Navigate to="/ticket-lists" />;
};

export default PublicRoute;
